var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.6 0H2.7A2.7 2.7 0 0 0 0 2.7v12.6A2.7 2.7 0 0 0 2.7 18h18.9a2.7 2.7 0 0 0 2.7-2.7V2.7A2.7 2.7 0 0 0 21.6 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2F3071",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m2.942 3.64 9.284 6.26 9.286-6.26"
  })));
};
export default SvgMessage;